module.exports = __webpack_public_path__ + "distribution/img/gongliu.54ccb8d1.png";